import { FeatureFlag } from '../FeatureFlag';

export const enableEnhancedTableProgress = new FeatureFlag({
    key: 'enable-enhanced-table-progress',
    defaultValue: false,
});
